import {FormControl, FormHelperText, SelectProps, makeStyles} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import classNames from 'classnames';
import React from 'react';
import {InputProps} from '../../models/FormInputs';
import {useDropdownOptions} from '../hooks/useDropdownOptions';
import {useEnabledSelectStyles} from './styles';

export interface Option {
  label: string;
  value: string;
}

type QuoteAutoCompleteProps = SelectProps &
  InputProps & {
    helperText?: React.ReactNode;
    dropdownVariant: DropdownVariant;
    searchKey: string;
    error?: boolean;
    value: string[];
    coverageCode?: string;
    onChange: (value: string[]) => void;
  };

const useDropdownStyles = makeStyles(() => ({
  quoteDropdown: {
    borderRadius: 0,
    marginTop: '0.5rem',
    marginBottom: '0.25rem',
    backgroundColor: 'transparent',
    color: '#000',
    borderColor: '#0075D1',
  },
}));

type DropdownVariant = 'Lookup' | 'AttributeValue';

export const QuoteAutocompleteMultiSelect = (props: QuoteAutoCompleteProps) => {
  const {
    dropdownVariant = 'AttributeValue',
    inputFieldProps,
    className,
    searchKey,
    error,
    value,
    label,
    onChange,
    helperText,
    coverageCode,
    ...otherProps
  } = props;

  const classes = useDropdownStyles({isDisabled: props.disabled});
  const options = useDropdownOptions(dropdownVariant, searchKey, coverageCode);
  const enabledSelectInputStyles = useEnabledSelectStyles();
  const selectedOptions = options.filter(opt => value.includes(opt.value));

  return (
    <FormControl required error={error} fullWidth>
      <Autocomplete<Option, true, false, false>
        multiple
        className={classNames(classes.quoteDropdown, className, {
          [enabledSelectInputStyles.input]: otherProps.disabled === false,
        })}
        disableCloseOnSelect
        options={options}
        getOptionLabel={option => option.label}
        value={selectedOptions}
        fullWidth
        getOptionSelected={(option, selected) => option.value === selected.value}
        style={{
          borderRadius: 0,
          backgroundColor: props.disabled ? '#E8E8E8' : 'transparent',
          color: props.disabled ? '#474747' : '#000',
        }}
        onChange={(_, newOptions) => {
          onChange(newOptions.map(opt => opt.value));
        }}
        size="small"
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            inputProps={{...params.inputProps, style: inputFieldProps?.style}}
            error={error}
          />
        )}
        onBlur={otherProps.onBlur as any}
      />
      <FormHelperText error={error} style={{color: 'red'}}>
        {helperText ?? ''}
      </FormHelperText>
    </FormControl>
  );
};
